import styled from 'styled-components';

import { TSvgProps } from '@r1-frontend/ui-react/components/svg/createSvg';
import { Paragraph4 } from '@r1-frontend/ui-react/components/typography/paragraph';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

export type TWithIconProps = {
    Icon: (props: TSvgProps) => JSX.Element,
    textColor?: COLORS,
    children: string,
}

const WithIcon = ({ Icon, textColor = COLORS.TextInfo, children, ...props }: TWithIconProps): JSX.Element => <div {...props}>
    <div><Icon/></div>
    <Paragraph4 $color={textColor}>{children}</Paragraph4>
</div>;

export default styled(WithIcon)`
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    
    align-items: flex-start;
    
    & > div:first-child {
        flex: 0 0 24px;
        margin-right: 12px;
        margin-top: -6px;
        
        border-radius: 50%;
        background-color: ${COLORS.BgSurface};
        padding: 6px;
    }
    
    ${Paragraph4} {
        margin: 0;
    }
`;
